import { ValidationKey } from '@/constants/validation-key';
import { ValidationReturn } from '@/validators/countryInstanceValidators';

export function onlyNumberValidation(value: string): ValidationReturn {
    const pattern = new RegExp(/^\d+$/, 'g');
    const isValid = pattern.test(value);
    return !isValid ? ValidationKey.OnlyDigits : undefined;
}
